module.exports = __webpack_public_path__ + "img/fg.df7be141.png";